// extracted by mini-css-extract-plugin
export default {"btn":"Buttom_btn__u5aOV"};